module.exports = __webpack_public_path__ + "static/media/map_img_m.a176c273.png";